import { Component, OnInit, OnDestroy } from "@angular/core";
import { SearchRequest, TankmixTest } from "../../../models/searchRequest";
import { HelenaApiService } from "../../../services/helena-api.service";
import { PreferencesService } from "../../../services/preferences.service";
import { ReferenceDataService } from "../../../services/reference-data.service";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { NamedId } from "../../../models/NamedId";
import { Subscription, forkJoin } from "rxjs";
import { KindPage } from "../../../enums/kind-page";
import { SearchHistoryService } from "../../../services/search-history.service";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { SearchRequestHistoryItem } from "../../../models/searchRequestHistoryItem";

@Component({
  selector: "app-helena-search",
  templateUrl: "./helena-search.component.html",
})
export class HelenaSearchComponent implements OnInit, OnDestroy {
  faFilePdf: any = faFilePdf;
  previousSearches: SearchRequest[] = [];
  showIntroduction = true;
  countryChoices: NamedId[] = [];
  yaraProductChoices: NamedId[] = [];
  activeIngredientChoices: NamedId[] = [];
  agrochemicalChoices: NamedId[] = [];
  results: TankmixTest[] = null;
  searchForm: UntypedFormGroup;
  searchHistoryItem: SearchRequestHistoryItem;
  // search: SearchRequest = {
  //   countryCode: 'US',
  //   activeIngredientCode: null,
  //   yaraChemicalId: null,
  //   agrochemicalCode: null,
  //   languageCode: null,
  // };
  searching: boolean;
  choicesSubscription: Subscription;
  preferencesSub: Subscription;
  constructor(
    private helenaApi: HelenaApiService,
    private preferencesService: PreferencesService,
    private fb: UntypedFormBuilder,
    private refData: ReferenceDataService,
    private searchHistory: SearchHistoryService,
    private route: ActivatedRoute
  ) {
    this.showIntroduction = true;

    this.searchForm = this.fb.group({
      countryCode: "US",
      activeIngredientCode: [null],
      yaraChemicalId: [null],
      agrochemicalCode: [null],
      extraRestriction: ["Helena"],
    });
  }
  ngOnDestroy(): void {
    this.choicesSubscription.unsubscribe();
    this.preferencesSub.unsubscribe();
  }

  ngOnInit() {
    this.preferencesService.forceToAmerica();
    this.preferencesSub = this.preferencesService.countryCode$.subscribe();

    this.choicesSubscription = forkJoin(
      this.refData.getHelenaProducts(),
      this.refData.getActiveIngredients(),
      this.refData.getagrochemicals()
    ).subscribe((data: any[]) => {
      this.yaraProductChoices = data[0];
      this.activeIngredientChoices = data[1];
      this.agrochemicalChoices = data[2];
    });

    // check if page comes from search history component
    let index = this.route.snapshot.params.id;
    if (index != undefined) {
      this.searchHistoryItem = this.searchHistory.getHistoryItem(index);
      if (this.searchHistoryItem == undefined) {
        return;
      }
      this.pathFormWithSearchCriteria();
    }
  }

  pathFormWithSearchCriteria() {
    var criteria = this.searchHistoryItem.criteria;
    this.searchForm.patchValue(criteria);
    this.performSearch();
  }

  private storeSearchCriteria(criteria: any, numberOfResults: number) {
    this.searchHistory.storeSearchCritera(
      criteria,
      numberOfResults,
      KindPage.FoliarTankmix
    );
  }

  searchAgain() {
    this.results = null;
  }
  resetSearch() {
    this.searchForm.patchValue({
      activeIngredientCode: null,
      yaraChemicalId: null,
      agrochemicalCode: null,
    });
  }
  toggleIntroduction() {
    this.showIntroduction = !this.showIntroduction;
  }
  performSearch() {
    this.searching = true;
    let val = this.searchForm.value;
    this.helenaApi
      .search({
        countryCode: val.countryCode,
        activeIngredientCode: val.activeIngredientCode?.id,
        agrochemicalCode: val.agrochemicalCode?.id,
        languageCode: null,
        yaraChemicalId: val.yaraChemicalId?.id,
        extraRestriction: val.extraRestriction,
      })
      .subscribe((x: TankmixTest[]) => {
        this.results = x;
        this.searching = false;

        // store result in local storage
        this.storeSearchCriteria(val, x.length);
      });
  }

  convertedAppRate(inp: number) {
    return this.preferencesService.convertApplicationUnits(inp);
  }
  convertedWaterRate(inp: number) {
    return this.preferencesService.convertWaterUnits(inp);
  }
  convertPowderUnits(inp:number) {
    return this.preferencesService.convertPowderUnits(inp);
  }
}
